import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AccountService } from '../../services/account.service';
import { GetAccountDetailsDto, UpdateAccountDetailsDto } from '../../models/account/account.models';
import { ValidateComponent } from '../../components/common/validateComponent/validate.component';
import { LoggedInUser, LoggedInUserService } from '../../auth/logged.in.user';
import { Address } from '../../models/common/address';
import {RouterService} from '../../services/routerService';

@Component({
    selector: 'account-details',
    template: require('./account.details.component.html'),
    styles: [require('./personal.account.shared.css'), require('./account.details.component.css')]
})
export class AccountDetailsComponent extends ValidateComponent implements OnInit, OnDestroy {
    details: GetAccountDetailsDto;

    id: number;
    validatePassword: string;

    newPassword: string;
    confirmNewPassword: string;

    changingPassword: boolean;

    canChangeCompanyName: boolean;

    domainChangeEmail: string;
    domainChangeValidate: string;

    user: LoggedInUser;
    subscribed: boolean;
    isTeamMember: boolean;

    @BlockUI('acc-details-block') private accDetailsBlock: NgBlockUI;
    @ViewChild('validateForm', { static: false }) currentForm;

    constructor(private readonly accountService: AccountService, userService: LoggedInUserService, private readonly routerService: RouterService) {
        super();

        this.user = userService.getCurrentUser();
        this.subscribed = !this.user.canAdHoc('notSubscribed');

        this.id = this.user.userId;
        this.canChangeCompanyName = this.user.canAdHoc('changeCompanyName');

        this.formErrors = {
            'firstName': '',
            'lastName': '',
            'emailAddress': '',
            'companyName': '',
            'addressLine1': '',
            'addressLine2': '',
            'addressCity': '',
            'addressPostcode': '',
            'validatePassword': '',
            'newPassword': '',
            'confirmNewPassword': '',
            'domainChangeEmail': '',
            'domainChangeValidate': ''
        }

        this.validationMessages = {
            'firstName': {
                'required': 'First Name is required.'
            },
            'lastName': {
                'required': 'Last Name is required.'
            },
            'emailAddress': {
                'required': 'Email address is required.',
                'pattern': 'Must not conatain invalid characters (e.g. @).'
            },
            'companyName': {
                'required': 'Company Name is required.'
            },
            'validatePassword': {
                'required': 'You must enter your password to confirm your changes.'
            },
            'newPassword': {
                'pattern': 'Password is not valid.'
            },
            'confirmNewPassword': {
                'validateEqual': 'Passwords do not match.'
            }
        }

        if (this.user.role == "Tender Team Member") {
            this.isTeamMember = true;
        }
        else {
            this.isTeamMember = false;
        }

        this.details = new GetAccountDetailsDto();
        this.details.address = new Address();

        $('#domain-change-modal').modal();
        $('#domain-change-modal').modal('hide');
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');
        this.accDetailsBlock.start();
        this.getAccountDetails();
    }

    ngOnDestroy() {
        $('#domain-change-modal').modal('hide');
        document.body.classList.remove('personal-account-fit');
    }

    getAccountDetails() {
        this.accountService.getAccountDetails().subscribe((response: GetAccountDetailsDto) => {
            this.details = response;
            this.accDetailsBlock.stop();
        });
    }

    onSubmit() {
        this.removeErrors();

        let errors: boolean = false;

        if (!this.showErrors(true)) {
            errors = true;
        }

        if (this.canChangeCompanyName &&
            !this.details.address.line1 &&
            !this.details.address.line2 &&
            !this.details.address.city &&
            !this.details.address.postcode) {
            this.formErrors['addressLine1'] = 'Address must be populated.';
            this.formErrors['addressLine2'] = 'Address must be populated.';
            this.formErrors['addressCity'] = 'Address must be populated.';
            this.formErrors['addressPostcode'] = 'Address must be populated.';

            errors = true;
        }

        if (errors) {
            return;
        }

        this.accDetailsBlock.start();

        const dto = new UpdateAccountDetailsDto(this.details);
        dto.id = this.id;
        dto.validatePassword = this.validatePassword;
        dto.newPassword = this.newPassword;
        dto.confirmNewPassword = this.confirmNewPassword;

        this.accountService.updateAccountDetails(dto).subscribe(() => {
                this.routerService.router.navigateByUrl('/tenders/mymatches');
            },
            () => {
                this.validatePassword = null;
                this.accDetailsBlock.stop();
            });
    }

    cancelDomainChangeRequest() {
        this.formErrors['domainChangeEmail'] = null;
        this.formErrors['domainChangeValidate'] = null;

        this.domainChangeEmail = null;
        this.domainChangeValidate = null;
    }

    submitDomainChangeRequest() {
        this.removeErrors();

        let errors: boolean = false;

        if (!this.domainChangeEmail) {
            this.formErrors['domainChangeEmail'] = 'Email address is required.';
            errors = true;
        }

        if (!this.domainChangeValidate) {
            this.formErrors['domainChangeValidate'] = 'You must enter your password to confirm your request.';
            errors = true;
        }

        if (errors) {
            return;
        }

        this.accDetailsBlock.start();

        this.accountService.requestDomainChange(this.domainChangeEmail, this.domainChangeValidate).subscribe(() => {
            $('#domain-change-modal').modal('hide');

            this.domainChangeEmail = null;
            this.domainChangeValidate = null;

            this.accDetailsBlock.stop();
        }, () => { this.accDetailsBlock.stop(); });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/account.details.component.ts